import { DefaultError, useMutation } from '@tanstack/react-query';
import { updateTodayLifeAreaTaskOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateTodayLifeAreaTaskOrderMutation = () =>
  useMutation<void, DefaultError, { id: ID; taskIds: ID[] }>({
    mutationFn: async ({ id, taskIds }) =>
      updateTodayLifeAreaTaskOrder([{ lifeAreaId: id, taskIds }]),
  });
